import { useNavigate } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function BillingCancelPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4" data-testid="billing-cancel-page">
      <Card className="w-full max-w-md border-gray-200 shadow-lg rounded-2xl">
        <CardContent className="p-8 text-center">
          <XCircle className="w-12 h-12 text-gray-400 mx-auto mb-4" />
          <h1 className="text-xl font-semibold text-gray-900">Checkout cancelled</h1>
          <p className="text-sm text-gray-500 mt-2">
            No charge was made. You can try again anytime.
          </p>
          <Button onClick={() => navigate("/generator")} className="mt-5 bg-gray-900 hover:bg-black">
            Back to Studio
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
